import React from "react";
import { COLORS } from "../../ui/Theme";
import { BeatLoader } from "react-spinners";
import { Box, Typography } from "@mui/material";

const Loading = ({ isText, color, size }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "10px",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          padding: 0.5,
          borderRadius: "12px",
          width: "fit-content",
          animation: "fadeEffect 2s infinite",
        }}
      >
        {isText && (
          <Typography fontSize={"16px"} color={color ? color : COLORS.BLUE}>
            پرتفو‌‌‌‌‌‌‌‌یـار
          </Typography>
        )}

        <BeatLoader
          color={color ? color : COLORS.BLUE}
          size={size ? size : "10px"}
        />
      </Box>
      <style jsx="true">
        {`
          @keyframes fadeEffect {
            0% {
              opacity: 1;
            }
            50% {
              opacity: 0.7;
            }
            100% {
              opacity: 1;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default Loading;
